import React, { useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import '../../styles/_tabImageStyles.scss';

const ImageTabs = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL;
  const [activeKey, setActiveKey] = useState('tab1'); // 'tab1' is initially active
  const [hoveredKey, setHoveredKey] = useState(null); // State to track hovered tab

  const getTabImageUrl = (imageName) => { // Removed isHover parameter as it's now handled by the image names directly
    return `${awsImageBaseUrl}images/WhatWeDo/${imageName}.png`;
  };

  const tabs = [
    {
      key: 'tab1',
      image: getTabImageUrl('1_GRAY'),
      activeImage: getTabImageUrl('1_RED'), // Image when the tab is active
      hoverImage: getTabImageUrl('1_RED'),  // Image when the tab is hovered (if not active)
      imageClass: 'pt-0'
    },
    {
      key: 'tab2',
      image: getTabImageUrl('2_GRAY'),
      activeImage: getTabImageUrl('2_RED'),
      hoverImage: getTabImageUrl('2_RED'),
      imageClass: 'pt-25'
    },
    {
      key: 'tab3',
      image: getTabImageUrl('3_GRAY'),
      activeImage: getTabImageUrl('3_RED'),
      hoverImage: getTabImageUrl('3_RED'),
      imageClass: 'pt-50'
    },
    {
      key: 'tab4',
      image: getTabImageUrl('4_GRAY'),
      activeImage: getTabImageUrl('4_RED'),
      hoverImage: getTabImageUrl('4_RED'),
      imageClass: 'pt-25'
    },
    {
      key: 'tab5',
      image: getTabImageUrl('5_GRAY'),
      activeImage: getTabImageUrl('5_RED'),
      hoverImage: getTabImageUrl('5_RED'),
      imageClass: 'pt-0'
    },
  ];

  return (
    <section>
      <div className="container">
        <div className="row text-left">
          <div className="col"><h3 className='font-bold text-center'>Brand Name Development Process</h3></div>
        </div>
        <Tab.Container activeKey={activeKey} onSelect={setActiveKey}>
          <Nav
            variant="tabs"
            className="border-0 justify-content-center flex-nowrap w-100"
            role="tablist"
          >
            {tabs.map(({ key, image, activeImage, hoverImage, imageClass }) => {
              // Determine the current background image based on activeKey and hoveredKey
              const currentImage = activeKey === key
                ? activeImage // Use activeImage if this tab is active
                : (hoveredKey === key ? hoverImage : image); // Otherwise, use hoverImage if hovered, else default image

              return (
                <Nav.Item key={key} className="flex-fill">
                  <Nav.Link
                    eventKey={key}
                    role="tab"
                    aria-controls={key}
                    aria-selected={activeKey === key}
                    className="d-flex flex-column align-items-center border-0 custom-tab-link pb-5"
                    style={{
                      flexGrow: 1,
                      flexBasis: 0,
                      minWidth: 0,
                      // Pass active image URL as a CSS variable for the active state
                      '--active-image': `url(${activeImage})`
                    }}
                    onMouseEnter={() => setHoveredKey(key)} // Set hovered key
                    onMouseLeave={() => setHoveredKey(null)} // Clear hovered key
                  >
                    <div
                      className={`tab-icon-container ${imageClass}`}
                      style={{
                        backgroundImage: `url(${currentImage})`, // Dynamically set background image
                      }}
                    >
                    </div>
                  </Nav.Link>
                </Nav.Item>
              );
            })}
          </Nav>
          <Tab.Content>
            {/* Content for Tab 1 */}
            <Tab.Pane eventKey="tab1">
              <div className="row text-left">
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>Project kickoff</h4>
                  <p className='font-bold'><span className='text-red'>Identify</span> and understand existing name strategy, positioning, market research, potential for growth.</p>
                </div>
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>Naming strategy</h4>
                  <p className='font-bold'><span className='text-red'>Uncover</span> insights and define objectives with key project stakeholders.</p>
                </div>
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>Competitive review</h4>
                  <p className='font-bold'>
                    <span className='text-red'>Analyze</span> how competing brands are presented, viewed, named, and accepted in the target market.</p>
                </div>
              </div>
              <div className="row text-left">
                <img src={`${awsImageBaseUrl}images/infoGraphic/Landscape_Analysis_infoGraphic.jpg`} className="card-img rounded-0" alt="LandscapeAnalysisGraphic" />
              </div>
            </Tab.Pane>

            {/* Content for Tab 2 */}
            <Tab.Pane eventKey="tab2">
              <div className="row text-left">
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>Naming Brief</h4>
                  <p className='font-bold'><span className='text-red'>Identify</span> the framework for developing the brand name candidates, based on the insights from the naming strategy.</p>
                </div>
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>Final Candidate List</h4>
                  <p className='font-bold'><span className='text-red'>Uncover</span> naming candidates through three separate iterations of deep source mining and ideation exercises.</p>
                </div>
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>Competitive review</h4>
                  <p className='font-bold'>
                    <span className='text-red'>Analyze</span> the name candidates with regard to structural analysis, trademark, domain, and common law availability and harvest a short list of ten to twelve final candidates.</p>
                </div>
              </div>
              <div className="row text-center">
                <div className="col pb-4">
                  <p className='font-bold text-2xl'>A Rigorous Linguistic Analysis</p>
                  <p>Our comprehensive screening is designed to eradicate conflict with identical or similar marks in relevant trademark classes, based on checks within but not limited to the following trademark databases:</p>
                </div>
              </div>
              <div className="row my-5">
                <img src={`${awsImageBaseUrl}images/WhatWeDo/EuropeanCommunity.png`} className="card-img rounded-0" alt="EuropeanCommunity" />
              </div>
              <div className="row text-center">
                <div className="col pb-4">
                  <p>Out team also has expertise in Boolean, Truncation, and Wildcard search techniques to supplement the trademark clearance checks performed through our online database inspection.</p>
                </div>
              </div>
            </Tab.Pane>

            {/* Content for Tab 3 */}
            <Tab.Pane eventKey="tab3">
              <div className="row text-center">
                <div className="col pb-4">
                  <p className='font-bold text-2xl'>A Rigorous Linguistic Analysis</p>
                  <p className='my-5'>From the perspectives of acoustic phonetics, phonology, and morphology in particular, our lexical theorists pay extraordinary attention to all facets of linguistic nuance. Looking at the phonemic structure, or the breakdown of distinct sounds in a given word, our team assesses the acoustic and articulatory properties of all adjacent sounds and consonant clusters.</p>
                  <p className='my-5'>Once we affirm that no harsh sounds are found at phonemic joints or intra-syllabically, we consider the semantic qualities and evocations of all morphemes, or units of meaning.</p>
                  <p className='mt-5'>Broken down even further, we specifically examine how our created words fare with regard to:</p>
                </div>
              </div>
              <div className="row">
                <img src={`${awsImageBaseUrl}images/WhatWeDo/LinguisticAnalysis.png`} className="card-img rounded-0" alt="LinguisticAnalysis" />
              </div>
              <div className="row text-center">
                <div className="col pb-4">
                  <p>Our team also has expertise in Boolean, Truncation, and Wildcard search techniques to supplement the trademark clearance checks performer through our online database inspection.</p>
                </div>
              </div>
              <div className="row text-center">
                <div className="col pb-4">
                  <p className='font-bold text-2xl'>Linguistic ScoreCard Analysis: <br />An Examination of Sound, Structure, & Meaning</p>
                  <p>Each of the final, preferred 10-12 brand names created will be subjected to our ScoreCard* analysis, based on the following categories:</p>
                </div>
              </div>
              <div class="row justify-content-center text-left pb-5">
                <div class="col-md-4">
                  <ul class="mb-0">
                    <li>Scriptability</li>
                    <li>Aural Comprehensibility</li>
                    <li>Visual Aesthetics</li>
                    <li>Syllabic Balance</li>
                    <li>Phonetic Viability</li>
                  </ul>
                </div>
                <div class="col-md-4">
                  <ul>
                    <li>Evocative Semantics</li>
                    <li>Durability & Longevity</li>
                    <li>Ease of Pronunciation</li>
                    <li>Gender Properties</li>
                    <li>Phonemic Symplicity</li>
                  </ul>
                </div>
              </div>
            </Tab.Pane>

            {/* Content for Tab 4 */}
            <Tab.Pane eventKey="tab4">
              <div className="row text-left">
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>Recruitment</h4>
                  <p className='font-bold'><span className='text-red'>Identify</span> a sample of 200 key users and construct a project specific questionnaire.</p>
                </div>
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>Interviews</h4>
                  <p className='font-bold'><span className='text-red'>Uncover</span> user insights on each name candidate by probing participants during one-on-one interviews.</p>
                </div>
                <div className="col-12 col-lg-4 pb-4">
                  <h4 className='text-2xl'>ScoreCard Analysis</h4>
                  <p className='font-bold'>
                    <span className='text-red'>Provide</span> a quantitative score for each of the created brand names.</p>
                </div>
              </div>
              <div className="row text-left">
                <img src={`${awsImageBaseUrl}images/WhatWeDo/ScoreCardCategories.png`} className="card-img rounded-0" alt="ScoreCardCategories" />
              </div>
            </Tab.Pane>

            {/* Content for Tab 5 */}
            <Tab.Pane eventKey="tab5">
              <div className="row text-center">
                <div className="col pb-4">
                  <p>Each of the final, preferred 10-12 brand names created will be subjected to our ScoreCard* analysis, based on the following categories:</p>
                </div>
              </div>
              <div className="row text-left">
                <img src={`${awsImageBaseUrl}images/WhatWeDo/lineGraph.png`} className="card-img rounded-0" alt="lineGraph" />
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </section>
  );
};

export default ImageTabs;